import { css } from '@emotion/react'

export const containerCss = css`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  margin-top: 28px;
  padding-top: 10px;
`

export const formControlCss = css`
  min-width: 160px;
`

export const selectCss = css`
  background-color: #fff;
`
export const inputLabelCss = css`
  color: black;
  &.MuiInputLabel-shrink {
    transform: translate(0px, -13px) scale(0.75);
  }
`

export const chipCss = ({ bgColor, fgColor }: { bgColor: string; fgColor: string }) => css`
  background-color: ${bgColor};
  color: ${fgColor};
  margin: 0px;
  padding: 0px;
  height: 20px;
  font-size: 10px;
  font-weight: 700;
`
